export default "__VITE_ASSET__JiSb_Mfi__"